
export const HistoryDespCard = ({ item }) => {

    let deSerilize = JSON.parse(item.metadata);
    const performedBy = item.performedBy ?? item.agentName ?? "N/A";
    let deSerilizeException = item.actionStatus ? "" : JSON.parse(item.exception);
    //console.log(deSerilize);
    //console.log(deSerilizeException);

    let denialActionOpt = "";

    if (item.actionId == 8) {
        let denialOpt = deSerilize?.DenialActionType;
        denialActionOpt = denialOpt == 1 ? "Make this slot available again" : denialOpt == 2 ? "Delete this slot" : "Delete this slot and all other slots";
    }

    return (
        <>
            {
                item.actionStatus ?
                    <div>
                        {
                            item.actionId == 4 ?
                                <p className="mb-0">
                                    {
                                        <>
                                            <span className="fw-bold">Description : </span>
                                            <span>Delete</span>
                                            <span className="fw-bold px-1">{deSerilize.freeslotDeleteCount != undefined ? deSerilize.freeslotDeleteCount : ""}</span>
                                            <span>free slots using the Smart Calendar Agent Site.</span>
                                        </>
                                    }
                                </p>
                                : item.actionId == 1 ?
                                    <>
                                        <span className="fw-bold">Smart Calendar Status Updation: </span>
                                        <span className="px-1">{deSerilize.oldEstateStatus ? deSerilize.oldEstateStatus : ""}</span>
                                        <span> → </span>
                                        <span className="px-1">{deSerilize.newEstateStatus ? deSerilize.newEstateStatus : ""}</span>
                                    </>
                                    : item.actionId == 3 ?
                                        <p className="mb-0">
                                            <span className="fw-bold"> Description :</span>
                                            {/*<span> User created </span>*/}
                                            <span> {item.performedBy === "system" ? "System created" : "User created"} </span>
                                            <span className="fw-bold px-1"> {deSerilize.eventsCount} </span>
                                            <span> {item.performedBy === "system" ? "free slot automatically." : "free slots using Smart Calendar Agent Site"} </span>
                                        {/*    <span> free slots using Smart Calendar Agent Site</span>*/}
                                        </p>
                                        : item.actionId == 5 ?
                                            <p className="mb-0">
                                                <span className="fw-bold"> Description : </span>
                                                <span>Contact</span>
                                                <span className="fw-bold mx-1">{deSerilize?.eventDetail?.contacts[0]?.firstName} </span>
                                                <span className="fw-bold">{deSerilize?.eventDetail?.contacts[0]?.name} </span>
                                                <span>has requested for booking </span>

                                            </p>
                                            : item.actionId == 6 ?
                                                <p className="mb-0">
                                                    <span className="fw-bold"> Description : </span>
                                                    <span>Agent </span>
                                                    <span className="fw-bold mx-1">{deSerilize?.eventDetail?.agentDetail?.FirstName} {deSerilize?.eventDetail?.agentDetail?.Name} </span>
                                                    <span>has accepted the booking for the contact </span>
                                                    <span className="fw-bold mx-1"> {deSerilize?.eventDetail?.contactDetail?.FirstName} {deSerilize?.eventDetail?.contactDetail?.Name} </span>
                                                </p>
                                                : item.actionId == 12 ?
                                                    <p className="mb-0">
                                                        <span className="fw-bold"> Description : </span>
                                                        <span className=""> System has sent an email to Contact</span>
                                                        <span className="fw-bold mx-1"> {deSerilize?.contactDetail?.firstName ?? deSerilize?.contactDetail?.FirstName}</span>
                                                        <span className="fw-bold"> {deSerilize?.contactDetail?.name ?? deSerilize?.contactDetail?.Name} </span>
                                                    </p>
                                                    : item.actionId == 9 ?
                                                        <p className="mb-0">
                                                            <span className="fw-bold"> Description : </span>
                                                            <span className=""> System has sent an email to Agent</span>
                                                            <span className="fw-bold mx-1"> {deSerilize?.agentDetail?.firstName}</span>
                                                            <span className="fw-bold"> {deSerilize?.agentDetail?.name} </span>
                                                        </p>
                                                        : item.actionId == 8 ?
                                                            <div>
                                                                <p className="mb-1 mt-0">
                                                                    <span className="fw-bold"> Description : </span>
                                                                    <span className="mx-1"> Agent </span>
                                                                    <span className="fw-bold">{deSerilize?.eventDetail?.agentDetail?.FirstName} </span>
                                                                    <span className="fw-bold">{deSerilize?.eventDetail?.agentDetail?.Name} </span>
                                                                    <span className="">has refused booking of contact </span>
                                                                    <span className="fw-bold"> {deSerilize?.eventDetail?.contactDetail?.FirstName} </span>
                                                                    <span className="fw-bold">{deSerilize?.eventDetail?.contactDetail?.Name} </span>
                                                                </p>
                                                                <p className="mb-1 mt-0">
                                                                    <span className="fw-bold"> Reason : </span>
                                                                    <span className="mx-1"> {deSerilize?.Reason} </span>
                                                                </p>
                                                                <p className={`${deSerilize?.CustomMessage ? "mb-1 mt-0" : "d-none"}`}>
                                                                    <span className="fw-bold"> Message : </span>
                                                                    <span
                                                                        className="mx-1"
                                                                        style={{
                                                                            display: "inline-block",
                                                                            maxWidth: "300px",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            verticalAlign: "bottom",
                                                                        }}
                                                                        title={deSerilize?.CustomMessage}
                                                                    >
                                                                        {deSerilize?.CustomMessage}
                                                                    </span>
                                                                </p>
                                                                <p className="mb-1 mt-0">
                                                                    <span className="fw-bold"> Slot Management Options : </span>
                                                                    <span className="mx-1"> {denialActionOpt} </span>
                                                                </p>
                                                            </div>
                                                            : item.actionId == 2 ?
                                                                <p className="mb-0">
                                                                    <span className="fw-bold"> Description : </span>
                                                                    <span className=""> Contact</span>
                                                                    <span className="fw-bold mx-1"> {deSerilize?.contactDetail?.firstname}</span>
                                                                    <span className="fw-bold"> {deSerilize?.contactDetail?.lastname} </span>
                                                                    <span className="">has registered for the waiting list.</span>
                                                                </p>
                                                                : item.actionId == 7 ?
                                                                    <p className="mb-0">
                                                                        <span className="fw-bold"> Description : </span>
                                                                        <span className=""> Contact</span>
                                                                        <span className="fw-bold"> {deSerilize?.eventDetail?.contactDetail?.FirstName}</span>
                                                                        <span className="fw-bold"> {deSerilize.eventDetail?.contactDetail?.Name} </span>
                                                                        <span className="">has successfully booked a visit.</span>
                                                                    </p>
                                                                    :
                                                                    <p className="mb-0">
                                                                        {/*<span className="fw-bold"> Description :</span>*/}
                                                                        {/*<span>Testing for description</span>*/}
                                                                    </p>
                        }
                        <p className="mb-0"> <span className="fw-bold">Performed By:</span> {performedBy}</p>
                    </div>
                    :
                    <div>
                        {
                            <p className="mb-0">
                                {
                                    <>
                                        <span className="fw-bold">Error Message : </span>
                                        <span>{deSerilizeException?.message}</span>
                                    </>
                                }
                            </p>
                        }
                        <p className="mb-0"> <span className="fw-bold">Performed By:</span> system</p>
                    </div>
            }


        </>
    )

}